import Vue from 'vue'

Vue.component('UiBtn', require('./btn').default)
Vue.component('UiSocial', require('./social').default)
// Vue.component('UiCollapse', require('./collapse').default)
// Vue.component('UiSpinner', require('./spinner').default)
// Vue.component('UiBurger', require('./burger').default)
